"use strict";
//
// Copyright © 2020, 2021 Anticrm Platform Contributors.
// Copyright © 2021 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformEvent = void 0;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.broadcastEvent = broadcastEvent;
exports.setPlatformStatus = setPlatformStatus;
exports.monitor = monitor;
const status_1 = require("./status");
/**
 * @public
 */
exports.PlatformEvent = 'platform-event';
const eventListeners = new Map();
/**
 * @public
 * @param event -
 * @param listener -
 */
function addEventListener(event, listener) {
    const listeners = eventListeners.get(event);
    if (listeners !== undefined) {
        listeners.push(listener);
    }
    else {
        eventListeners.set(event, [listener]);
    }
}
/**
 * @public
 * @param event -
 * @param listener -
 */
function removeEventListener(event, listener) {
    const listeners = eventListeners.get(event);
    if (listeners !== undefined) {
        listeners.splice(listeners.indexOf(listener), 1);
    }
}
/**
 * @public
 */
async function broadcastEvent(event, data) {
    const listeners = eventListeners.get(event);
    if (listeners !== undefined) {
        const promises = listeners.map(async (listener) => {
            await listener(event, data);
        });
        await Promise.all(promises);
    }
}
/**
 * @public
 * @param status -
 * @returns
 */
async function setPlatformStatus(status) {
    if (status.severity === status_1.Severity.ERROR) {
        console.trace('Platform Error Status', status);
    }
    await broadcastEvent(exports.PlatformEvent, status);
}
/**
 * @public
 * @param status -
 * @param promise -
 * @returns
 */
async function monitor(status, promise) {
    void setPlatformStatus(status); // eslint-disable-line no-void
    try {
        const result = await promise;
        void setPlatformStatus(status_1.OK); // eslint-disable-line no-void
        return result;
    }
    catch (err) {
        void setPlatformStatus((0, status_1.unknownError)(err)); // eslint-disable-line no-void
        console.error(err);
        throw err;
    }
}
//# sourceMappingURL=event.js.map